import { computed, type App } from 'vue'
import type { Pinia } from 'pinia'

import {
  FLASHCARD_AUTOPLAY_AUDIO,
  FLASHCARD_AUTOFLIP,
  FLASHCARD_FORCE_DARK_MODE,
} from '../flashcard/context'

import { useUserSettingsStore } from '../stores/useUserSettingsStore'

export const installUserSettings = (app: App, pinia: Pinia) => {
  const settings = useUserSettingsStore(pinia)

  app.provide(
    FLASHCARD_FORCE_DARK_MODE,
    computed(() => settings.forceDarkMode),
  )
  app.provide(
    FLASHCARD_AUTOPLAY_AUDIO,
    computed(() => settings.autoplayAudio),
  )
  app.provide(
    FLASHCARD_AUTOFLIP,
    computed(() => settings.autoFlip),
  )

  return settings
}
